import Head from "next/head";
import { useRouter } from "next/router";

import { buildStorefrontMeta } from "../lib/storefrontMeta";

/**
 * Buyer storefront meta / og / twitter / favicon per DM2-247 lock.
 * Optional `path` overrides router.asPath (e.g. tests). Optional `robots` for noindex pages.
 */
export default function StorefrontHead({ store, path, robots }) {
  const router = useRouter();
  const pagePath = path ?? router.asPath ?? "/";
  const { title, description, pageUrl, image } = buildStorefrontMeta(store, pagePath);

  return (
    <Head>
      {robots ? <meta name="robots" content={robots} /> : null}
      {title ? <title>{title}</title> : null}
      {title ? <meta name="title" content={title} /> : null}
      <meta name="description" content={description} />
      {image ? <link rel="icon" href={image} /> : null}
      {pageUrl ? <link rel="canonical" href={pageUrl} /> : null}
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1,user-scalable=0"
      />

      <meta property="og:type" content="website" />
      {title ? <meta property="og:title" content={title} /> : null}
      <meta property="og:description" content={description} />
      {image ? <meta property="og:image" content={image} /> : null}
      {title ? <meta property="og:site_name" content={title} /> : null}
      {pageUrl ? <meta property="og:url" content={pageUrl} /> : null}

      <meta name="twitter:card" content="summary" />
      {pageUrl ? <meta name="twitter:url" content={pageUrl} /> : null}
      {title ? <meta name="twitter:title" content={title} /> : null}
      <meta property="twitter:description" content={description} />
      {image ? <meta property="twitter:image" content={image} /> : null}
    </Head>
  );
}
